import { validateSomething } from "../../Form/Validations";
import { toast } from "react-toastify";
import RestAPI from "@aws-amplify/api-rest";

export class Davis {

    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, i18n) {
        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const body = {
                    stationId: values.stationId,
                    tipo: "DAVIS",
                    sectorName: values.sectorName,
                    nodeName: values.sectorName,
                    apiKey: props.dialogState.data.apiKey,
                    secretKey: props.dialogState.data.secretKey,
                    locale: i18n.language,
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("external.login"),
                    validateFunction: this.validateLogin,
                    inputs: [
                        {
                            label: "API Key",
                            campo: "apiKey",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            label: "Secret Key",
                            campo: "secretKey",
                            validation: validateSomething,
                            component: "text",
                        },
                    ],
                },
                {
                    label: t("external.conectar"),
                    inputs: [
                        {
                            label: t("node.tipo.STATION"),
                            campo: "stationId",
                            validation: validateSomething,
                            component: "select",
                            optionsName: "davisStations",
                            optionLabel: "station_name",
                            optionKey: "station_id",
                            onChange: (value, props, options) => {
                                const sectorName = options.find(o => o.station_id === value)?.station_name ?? "";
                                props.setFieldValue("sectorName", sectorName);
                            }
                        },
                        {
                            label: t("external.sector-name"),
                            campo: "sectorName",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            component: "info",
                            triggeredBy: "stationId",
                            optionsKey: "station_id",
                            optionsName: "davisStations",
                            content: (_,__, props) => {
                                return (<>
                                    <div className="col-12 col-md-12">
                                        <label className="boldie text-left">
                                            {t("external.availableSensors")}
                                        </label>
                                    </div>
                                    <div className="mb-2 col-12 col-md-12 d-block">
                                        <ul>
                                            {Object.entries(props.dialogState.data.sensorTypes).map((type, id) => {
                                                return <li key={id}> {type[1].text} </li>;
                                            })}
                                        </ul>
                                    </div>
                                </>);
                            }
                        },
                    ],
                },
            ],
        };
    }

    static async validateLogin(values, props) {
        const isSubmitting = props.innerRef.current.isSubmitting;
        const errors = {};
        try {
            if (values) {
                const errApiKey = validateSomething(values.apiKey);
                if (errApiKey !== undefined) errors.apiKey = errApiKey;

                const errSecret = validateSomething(values.secretKey);
                if (errSecret !== undefined) errors.secretKey = errSecret;

                if(errors.apiKey || errors.secretKey) return errors;

                if (isSubmitting){
                    props.setForceLoading(true);

                    const endpoint = `/external/${props.farmId}/davis-credentials`;
                    const body = { secretKey: values.secretKey, apiKey: values.apiKey, locale: props.i18n.language };
                    const davisData = await RestAPI.post("apiAdminDropControl", endpoint, { body });

                    // set data that it will be used in the next step of the form
                    props.setDialogState(s => ({
                        ...s,
                        data: {
                            apiKey: values.apiKey,
                            secretKey: values.secretKey,
                            davisStations: davisData.stations,
                            sensorTypes: davisData.sensorTypes,
                        }
                    }));

                    props.setForceLoading(false);
                }
                return errors;
            }
        } catch (error) {
            if (error.response?.status === 401){
                toast.error(props.t("external.incorrectDavisKeys"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                errors.unknown = props.t("external.incorrectDavisKeys");
            } else {
                toast.error(props.t("external.error-sign-in"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                errors.unknown = props.t("external.error-sign-in");
            }
            props.setForceLoading(false);
            return errors;
        }
    }
    /**
   * @returns {import("../types").DialogState}
  */
    static migrateToV2Dialog(t, data) {
        return {
            visible: true,
            activeStep: 0,
            data: {},
            resolveBody: (values, props) => {
                const body =  {
                    nodoId: data.connection_data?.nodo_id,
                    stationId: values.stationId,
                    apiKey: props.dialogState.data.apiKey,
                    secretKey: props.dialogState.data.secretKey
                };
                return { url: `/external/${props.farmId}/migrate-davis`, body };
            },
            confirmButtonLabel: t("general.confirm"),
            skipCostStep: true,
            skipReviewStep: true,
            returnOnSuccess: true,
            steps: [
                {
                    label: t("external.login"),
                    validateFunction: this.validateLogin,
                    inputs: [
                        {
                            label: "API Key",
                            campo: "apiKey",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            label: "Secret Key",
                            campo: "secretKey",
                            validation: validateSomething,
                            component: "text",
                        },
                    ],
                },
                {
                    label: t("external.conectar"),
                    inputs: [
                        {
                            label: t("node.tipo.STATION"),
                            campo: "stationId",
                            validation: validateSomething,
                            component: "select",
                            optionsName: "davisStations",
                            optionLabel: "station_name",
                            optionKey: "station_id",
                        },
                    ],
                },
            ],
        };
    }
}
